module.exports = __webpack_public_path__ + "static/media/logo-livestock.442ad965.svg";